
import axios from 'axios'
import { url } from './url'
import queryStringUtil from "query-string";

function queryString(query) {
    var queryParams = {
        page: query.page,
        pageSize: query.pageSize,
        macAddress: query.macAddress,
        partner: query.partner._id,
    };
    return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket"
    });
}

function getShippings(query) {
    var urlString = `${url}/partner-shipping?${queryString(query)}`;
    return axios
        .get(urlString)
        .then(res => {
            return {
                total: res.data.total,
                shippings: res.data.shippings.map(shipping => {
                    return {
                        _id: shipping._id,
                        shippingName: shipping.name,
                        hardwares: shipping.hardwares,
                        totalHardwares: shipping.hardwares.length,
                        partner: shipping.partner,
                        type: shipping.type,
                        createdAt: shipping.createdAt,
                        status: shipping.status,
                        image: shipping.image
                    };
                })
            }
        });
}

function createShipping(shipping) {
    return axios.post(`${url}/partner-shipping`, shipping)
        .then(resp => {
            return resp.data
        })
}
function sendMailShippings(shipping) {
    return axios.post(`${url}/partner-shipping/send_mail`, shipping)
        .then(resp => {
            return resp.data
        })
}
function updateShipping(shipping) {
    return axios.put(`${url}/partner-shipping/${shipping._id}`, shipping)
        .then(resp => {
            return resp.data
        })
}
export default {
    getShippings,
    createShipping,
    updateShipping,
    sendMailShippings
};